import {initialPunchClockState, IPunchClockState} from '@app/core/store/state/punch-clock.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EPunchClockActions, PunchClockActions} from '@app/core/store/actions/punch-clock.actions';

export const punchClockReducers = (
	state = initialPunchClockState,
	action: PunchClockActions | ErrorActions,
): IPunchClockState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isUsersLoading: false,
				isDayNotesLoading: false,
			};
		}
		case EPunchClockActions.GetPunchClockUsers: {
			return {
				...state,
				isUsersLoading: true,
			};
		}
		case EPunchClockActions.GetPunchClockUsersSuccess: {
			return {
				...state,
				isUsersLoading: false,
				users: action.users,
				usersPagination: action.pagination,
			};
		}
		case EPunchClockActions.PunchInUserSuccess: {
			return {
				...state,
				isUsersLoading: false,
				users: state.users.map(u => u.id === action.user.id ? action.user : u),
			};
		}
		case EPunchClockActions.PunchOutUserSuccess: {
			return {
				...state,
				isUsersLoading: false,
				users: state.users.map(u => u.id === action.user.id ? action.user : u),
			};
		}
		case EPunchClockActions.GetPunchDayNotes: {
			return {
				...state,
				isDayNotesLoading: true,
			};
		}

		case EPunchClockActions.GetPunchDayNotesSuccess: {
			return {
				...state,
				isDayNotesLoading: false,
				dayNotes: [...state.dayNotes, ...action.dayNotes],
				dayNotesPagination: action.pagination,
			};
		}
		case EPunchClockActions.GetPunchDepartmentSuccess: {
			return {
				...state,
				department: action.department,
			};
		}
		case EPunchClockActions.SetPunchPinCodeSuccess: {
			return {
				...state,
				users: state.users.map(u => u.id === action.user.id ? action.user : u),
			};
		}
		case EPunchClockActions.ClearPunchDayNotes: {
			return {
				...state,
				dayNotes: [],
				dayNotesPagination: undefined,
			};
		}
		default:
			return state;
	}
};
